export const landingAnalyticsTags = ["LandingAnalytics"];

export interface LandingAnalyticsFilters {
    event?: string;
    visitor_id?: string;
    user_id?: string | number;
    ref_code?: string;
    source_page?: string;
    language?: string;
    resolution?: string;
    date_from?: string;
    date_to?: string;
    page?: number;
    per_page?: number;
}

export interface LandingAnalyticsEvent {
    id: number;
    event: string;
    visitor_id: string;
    user_id: number | null;
    ref_code: string | null;
    source_page: string | null;
    language: string | null;
    resolution: string | null;
    user_agent: string | null;
    ip_address: string | null;
    created_at: string;
    updated_at: string;
}

export interface LandingAnalyticsStats {
    unique_visitors: number;
    visits: number;
    clicks: number;
    register: number;
    video_view: number;
}

export interface LandingAnalyticsFilterOptions {
    events: string[];
    pages: string[];
    languages: string[];
    resolutions: string[];
}

export interface LandingAnalyticsChartData {
    date: string;
    unique_users: number;
    visits: number;
    clicks: number;
    register: number;
    video_view: number;
}

export const landingAnalyticsEndpoints = {
    getLandingAnalyticsEvents: {
        query: (params: LandingAnalyticsFilters) => ({
            url: "/admin/analytics/landing",
            params,
        }),
    },
    getLandingAnalyticsStats: {
        query: (params: LandingAnalyticsFilters) => ({
            url: "/admin/analytics/landing/stats",
            params,
        }),
    },
    getLandingAnalyticsFilterOptions: {
        query: () => "/admin/analytics/landing/filter-options",
    },
    getLandingAnalyticsChart: {
        query: (params: { date_from?: string; date_to?: string }) => ({
            url: "/admin/analytics/landing/chart",
            params,
        }),
    },
    getLandingAnalyticsVideoStats: {
        query: (params: { date_from?: string; date_to?: string }) => ({
            url: "/admin/analytics/landing/video-stats",
            params,
        }),
    },
};

export interface LandingVideoStat {
    video_title: string | null;
    url: string | null;
    views_count: number;
    total_duration: number;
    avg_duration: number;
}
